import { render } from "./sliderDesktop.vue?vue&type=template&id=70536d16"
import script from "./sliderDesktop.vue?vue&type=script&lang=js"
export * from "./sliderDesktop.vue?vue&type=script&lang=js"

import "./sliderDesktop.vue?vue&type=style&index=0&id=70536d16&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__